module.exports = __webpack_public_path__ + "static/media/thumbs-up-blue.28a83644.svg";